import { useSelector } from 'react-redux'
import { AppState } from 'state'

export function useIsNetworkUnavailable(): boolean {
  return useSelector<AppState, boolean>((state) => {
    return state?.app?.isNetworkUnavailable
  })
}
